<template>
<el-dialog :visible.sync="dialogVisible" top="0" width="733px" :before-close="closeModal">
        <div class="d-flex row justify-content-center">
            <div>
                <CircleMoney :colorCircle="getPrimaryColorHex.two" :color="getPrimaryColorHex.four" class="d-flex mt-5 mb-2 mx-auto"/>
                <h3 class="c-ndarkthree bold text-center mb-2">
                    Definir limite de crédito
                </h3>
                <p>
                    Estabeleça um valor de limite de crédito para este sacado
                </p>
            </div>
            <div v-if="creditLimit.totalCreditLimit && !isCashforce" class="bgc-nlightthree py-3 mt-4 col-8 container-credit rounded">
                <div class="d-flex flex-column align-items-center mt-3">
                    <caption class="m-0 c-nmidone">Valor Geral</caption>
                    <p class="c-ndarkfour bold">R$ {{ creditLimit.totalCreditLimit | formatMoney }}</p>
                </div>
                <hr style=" width:341px;" class="hr-credit mb-3 mt-3">
                <div class="d-flex align-items-center mb-3">
                    <div class="d-flex flex-column align-items-center mr-3">
                        <caption class="m-0 c-nmidone">Valor utilizado</caption>
                        <p class="c-ndarkfour bold">R$ {{ creditLimit.usedCreditLimit | formatMoney }}</p>
                    </div>
                    <div class="d-flex flex-column align-items-center ml-3">
                        <caption class="m-0 c-nmidone">Valor disponível</caption>
                        <p class="c-ndarkfour bold">R$ {{ creditLimit.availableCreditLimit | formatMoney }}</p>
                    </div>
                </div>
            </div>
            <div v-else-if="creditLimit.totalCreditLimit && isCashforce" class="bgc-nlightthree py-3 mt-4 col-8 container-credit rounded">
                <div class="d-flex flex-column align-items-center mt-3">
                    <caption class="m-0 c-nmidone">Valor Atual</caption>
                    <p class="c-greenfour bold">R$ {{ creditLimit.totalCreditLimit | formatMoney }}</p>
                </div>
            </div>
            <div class="col-8 mt-4 mb-5">
                <h6 class="regular">
                    {{creditLimit.totalCreditLimit ? 'Novo valor' : 'Valor'}}
                </h6>
                <el-input :class="getPrimaryColor" placeholder="R$ 0,00" v-model.lazy="newCreditLimit" v-money="money" class="input-money p-0 cl-input" ref="creditLimitInput">
                    <span slot="prefix">R$</span>
                </el-input>
            </div>
        </div>
        <span slot="footer" class="dialog-footer d-flex justify-content-end align-items-center">
            <router-link to="" @click.native="closeModal"  :class="`${getPrimaryColor} c-ndarkfour mr-4`">
                Cancelar
            </router-link>
            <button :class="`btn btn-${getPrimaryColor}`" @click="updateCreditLimit" :disabled="isLoading">
                Salvar
            </button>
        </span>
</el-dialog>
</template>

<script>
// Libraries
import { VMoney } from 'v-money'

// Utils
import { formatMoney } from '@/utils/formatters'

// Icons
import CircleMoney from '@/components/icons/CircleMoney'

// APIs
import getEconomicGroupCreditLimit from '@/api/getEconomicGroupCreditLimit'
import getCreditLimitPerProvider from '@/api/getCreditLimitPerProvider'
import updateEconomicGroupSponsor from '@/api/updateEconomicGroupSponsor'
import updateCreditLimitPerProvider from '@/api/updateCreditLimitPerProvider'


export default {
    components: {
        CircleMoney
    },
    props: {
        dialogVisible: {
            required: true,
            type: Boolean,
            default: false
        },
        selectedEconomicGroupId: {
            required: true,
        },
        isPerProvider: {
            type: Boolean,
            default: false,
        },
        selectedProviderId: {
            default: null
        }
    },
    data() {
        return {
            money: {
                decimal: ',',
                thousands: '.',
                precision: 2,
            },
            creditLimit: {
                totalCreditLimit: 0,
                usedCreditLimit: 0,
                availableCreditLimit: 0,
            },
            newCreditLimit: null,
            isLoading: false,
        }
    },
    watch: {
        async dialogVisible(newValue) {
            if (newValue) {
                if(this.isPerProvider){
                    await this.getCreditLimit(this.selectedEconomicGroupId, this.selectedProviderId)
                } else {
                    await this.getCreditLimit(this.selectedEconomicGroupId)
                }
             
                this.$refs.creditLimitInput.$refs.input.value = formatMoney(this.creditLimit.totalCreditLimit)   
            }
        }
    },
    methods: {
        closeModal() {
            this.$emit('update')
            this.$emit('closeModal', false)
        },
        async updateCreditLimit() {
            this.isLoading = true
            const creditLimitNumber = this.newCreditLimit.split('.').join('').replace(',', '')
            if (this.isPerProvider) {
                await updateCreditLimitPerProvider(this.selectedEconomicGroupId, this.selectedProviderId, { creditLimit: creditLimitNumber }) 
                this.$notify({
                    title: 'Limite de crédito definido com sucesso.',
                    message: '',
                    type: 'success',
                    duration: 3000,
                    offset: 100,
                    showClose: false,
                });
            } else {
                await updateEconomicGroupSponsor(this.selectedEconomicGroupId, { creditLimit: creditLimitNumber }) 
                this.$notify({
                    title: 'Limite de crédito definido com sucesso.',
                    message: '',
                    type: 'success',
                    duration: 3000,
                    offset: 100,
                    showClose: false,
                });
            }
            this.closeModal()
            if (this.isPerProvider) this.$emit('reload')
            this.isLoading = false
            //this.$router.push(`buyers/providers/${this.selectedEconomicGroupId}`)
        },
        async getCreditLimit(economicGroupId, providerId = null) {
            const creditLimit = providerId ? await getCreditLimitPerProvider(economicGroupId, providerId) : await getEconomicGroupCreditLimit(economicGroupId)

            if(!creditLimit.totalCreditLimit){
                creditLimit.usedCreditLimit = 0
                creditLimit.availableCreditLimit = 0
            }

            this.creditLimit = creditLimit
        },
    },
    directives: {
        money: VMoney
    },
}
</script>
<style lang="scss">
    .cl-input{
        .el-input__inner, .el-input__prefix{
            height: 48px!important;
        }

        .el-input__prefix {
            top: 4px;
            left: 20px;
        }

        .el-input__inner {
            padding-left: 40px;
            border-color: #CED4E0!important;
        }
    }

    .container-credit {
        display: flex;
        flex-direction: column;
        align-items: center;
    }
    .hr-credit {
        height: 1px !important;
        border: unset;
        background-color: #DFE2EB;
    }
</style>